import React from "react";
import { Box } from "theme-ui";

import HeaderBar from "components/HeaderBar";

interface MainContainerProps {
  children: React.ReactNode;
  contentPadding: string | number;
  hasBackButton: boolean;
  hasMenuButton: boolean;
  title: string;
  onGoBack?: () => void;
}

const defaultProps = {
  contentPadding: "15px",
  hasBackButton: false,
  hasMenuButton: true,
  title: "공뿌마켓 POS",
};

function MainContainer({
  children,
  contentPadding,
  title,
  onGoBack,
}: MainContainerProps) {
  return (
    <Box sx={{ height: "100vh" }}>
      <HeaderBar
        hasBackButton={false}
        hasMenuButton={false}
        title={title}
        onGoBack={onGoBack}
      />
      <Box
        p={contentPadding}
        sx={{
          height: "calc(100vh - 50px)",
          overflowY: "auto",
          width: "100%",
        }}
      >
        {children}
      </Box>
    </Box>
  );
}

MainContainer.defaultProps = defaultProps;

export default MainContainer;
